export default __webpack_public_path__ + "static/marketing-presentation_kz-f6fcb724f0b43c3f22d4fbe16f5cc3f3.png";